/* eslint-disable @typescript-eslint/no-extra-semi */
import Web3 from 'web3'
import { formatNumber } from 'utils/formatBalance'
import { BigNumber } from 'bignumber.js'

export async function loadBlockchainData(account) {
  if (window.ethereum) {
    const web3 = new Web3(window.ethereum as any)

    // ETH Balance
    const ethBalance = await web3.eth.getBalance(account)

    // Token Balance
    const networkId = await web3.eth.net.getId()

    // Decimal
    const decimalsBNB = 18

    return {
      name: 'BNB Token',
      symbol: 'BNB',
      address: account,
      balance: formatNumber(+ethBalance / 10 ** 18, 0),
      chainId: networkId,
      decimals: decimalsBNB,
    }
  }

  return null
}

export async function getBalanceByAccount(contract, account) {
  return new Promise((resolve, reject) => {
    ;(async () => {
      if (contract) {
        const balance = await contract.methods.balanceOf(account).call()
        const decimals = await contract.methods.decimals().call()
        const parseBalance = new BigNumber(balance).shiftedBy(-decimals).toNumber()
        resolve({ balance: parseBalance })
      } else {
        reject(new Error('Cannot read contract, please try again later.'))
      }
    })()
  })
}
